export default __webpack_public_path__ + "static/media/swipe-right.9513e9a0.png";